/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Title from "../../components/Form/Title";
import Button from "../../components/Form/Button";
import useLogin from "../../hooks/useLogin";
import useFechas from "../../hooks/useFechas";
import { FacturasAdd } from "../../service/facturas";
import Swal from "sweetalert2";

const formatFecha = (fecha) => {
  if (!fecha) return "";
  const [anio, mes, dia] = String(fecha).slice(0, 10).split("-");
  if (!anio || !mes || !dia) return fecha;
  return `${dia}/${mes}/${anio}`;
};

const formatMoneda = (valor) =>
  (parseFloat(valor) || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

/**
 * Subir facturas (rol proveedor).
 *
 * Antes esta pantalla no guardaba nada: los botones llamaban por error a
 * endpoints de Clientes (ValidarXML/ValidarCartaFiscal -> ClientesGet/Add) y
 * no existía forma de decir a qué fecha de pago correspondía la factura. Para
 * cuadrar un pago contra su comprobante, el proveedor ahora elige de su
 * propia lista de fechas de pago antes de subir el XML/PDF.
 */
export default function Index() {
  const { proveedor_id, token } = useLogin();
  const { Fecha, FechasGetService } = useFechas();
  const [fechaPagoId, setFechaPagoId] = useState("");
  const [xml, setXml] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    FechasGetService(proveedor_id, token);
  }, [proveedor_id, token]);

  const subir = () => {
    if (!fechaPagoId) {
      Swal.fire({ icon: "error", title: "Falta la fecha de pago", text: "Selecciona a qué fecha de pago corresponde la factura." });
      return;
    }
    if (!xml && !pdf) {
      Swal.fire({ icon: "error", title: "Falta el archivo", text: "Sube al menos el XML o el PDF de la factura." });
      return;
    }

    const data = new FormData();
    data.append("fecha_pagos_id", fechaPagoId);
    if (xml) data.append("xml", xml);
    if (pdf) data.append("pdf", pdf);

    setGuardando(true);
    FacturasAdd(data, token)
      .then((respuesta) => {
        if (respuesta?.errors) {
          const primerError = Object.values(respuesta.errors)[0];
          Swal.fire({ icon: "error", title: "No se pudo subir", text: primerError ? primerError[0] : "Revisa los datos." });
          return;
        }
        if (respuesta?.guardado !== true) {
          Swal.fire({ icon: "error", title: "No se pudo subir", text: "Intenta de nuevo." });
          return;
        }
        Swal.fire({ icon: "success", title: "Factura subida", confirmButtonColor: "#3b82f6" });
        setFechaPagoId("");
        setXml(null);
        setPdf(null);
        document.querySelectorAll('.facturas-form input[type="file"]').forEach((input) => { input.value = ""; });
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo conectar con el servidor." });
      })
      .finally(() => setGuardando(false));
  };

  return (
    <div className="container">
      <div className="crud-header">
        <Title title="Subir facturas" className="crud-title" />
        <span className="crud-fecha">{new Date().toLocaleDateString()}</span>
      </div>
      <div className="crud-card facturas-form">
        <div className="row g-3">
          <div className="col-md-6">
            <label>Fecha de pago</label>
            <select
              className="form-control"
              value={fechaPagoId}
              onChange={(e) => setFechaPagoId(e.target.value)}
            >
              <option value="">Selecciona la fecha de pago a facturar</option>
              {Fecha.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.proyecto} · {formatFecha(f.fecha)} · {formatMoneda(f.monto)}
                  {f.status ? ` · ${f.status}` : ""}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>XML</label>
            <input
              accept=".xml"
              type="file"
              className="form-control"
              onChange={(e) => setXml(e.target.files[0] ?? null)}
            />
          </div>
          <div className="col-md-3">
            <label>PDF</label>
            <input
              accept=".pdf"
              type="file"
              className="form-control"
              onChange={(e) => setPdf(e.target.files[0] ?? null)}
            />
          </div>
          <div className="col-md-12 d-flex justify-content-end">
            <Button type="button" label={guardando ? "Subiendo..." : "Subir"} disabled={guardando} onClick={subir} />
          </div>
        </div>
      </div>
    </div>
  );
}
